import DiscussionPanel from '@/components/module/projects/discussion/DiscussionPanel';
import { useProjectDiscussions } from '@hooks/projects/discussion/useProjectDiscussions';

/** Project discussion: same layout as main Chat (header, message list, MessageCompose at bottom). */
export default function ProjectDiscussionTab({ projectId }) {
    const {
        discussions,
        isLoading: discussionsLoading,
        createPost,
        createPostPending,
        editPost,
        editPostPending,
        deletePost,
        deletePostPending,
    } = useProjectDiscussions(projectId);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
                height: '100%',
                alignSelf: 'stretch',
                overflow: 'hidden',
            }}
        >
            <DiscussionPanel
                variant="chat"
                projectId={projectId}
                discussions={discussions}
                isLoading={discussionsLoading}
                createPost={createPost}
                createPostPending={createPostPending}
                editPost={editPost}
                editPostPending={editPostPending}
                deletePost={deletePost}
                deletePostPending={deletePostPending}
                sectionLabel="Add Comments"
                emptyTitle="No discussion yet"
                emptyDesc="Post a message below to start the conversation."
            />
        </div>
    );
}
